import { message } from "antd";
import { EmailObject, ReviewEmailData } from "~/types/email";
import { INTENTS } from "~/utils";
import { getAuth } from "firebase/auth";
import { apiClient } from "~/services/apiClient";
import { sendEmail } from "./sendEmail";

// TODO [Translate]

/**
 * Prepares the review email via Lambda (tenant, unit, manager lookup),
 * then sends via Firestore (Trigger Email extension).
 */
export const sendReviewEmail = async (payload: ReviewEmailData) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) {
      throw new Error("You have been logged out"); // TODO [Translate]
    }

    const result = await apiClient.sendIntent<EmailObject>(
      INTENTS._prepare_review_email,
      {
      authUID: user.uid,
      title: payload.title,
      details: payload.details,
      rating: payload.rating,
      recommend: payload.recommend,
      image: payload.image,
      imageName: payload.imageName,
      },
    );

    if (!result.success || !result.data) {
      throw new Error(result.error ?? "Failed to prepare review email");
    }

    return await sendEmail(result.data as EmailObject);
  } catch (error: unknown) {
    const err = error as Error;
    message.error(err.message);
    console.error("send review email", error);
    return {
      success: false,
      data: {},
      error,
    };
  }
};
